import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import KanbanView from './KanbanView.vue';

const KANBAN_PERMISSIONS = [...ROLES, ...CONVERSATION_PERMISSIONS];

// ACESSO-01 (L8b): com a chave ACESSO_GRANULAR ligada, o quadro pede o `kanban:read` (`pipelines#index`, `#board`), e o
// funil novo, o `kanban:manage` (`pipelines#create`), como no servidor.
const ESCOPOS_DO_QUADRO = ['kanban:read'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_index',
    component: KanbanView,
    meta: {
      permissions: KANBAN_PERMISSIONS,
      escopos: ESCOPOS_DO_QUADRO,
      featureFlag: FEATURE_FLAGS.KANBAN,
    },
  },
  // Declared before the :pipelineId route so the intent is obvious at a glance, though
  // vue-router would score the static segment higher either way. A route rather than a
  // bus event so the sidebar entry is an ordinary link: it inherits the same permission
  // and feature-flag resolution as every other leaf, and the dialog is deep-linkable.
  {
    path: frontendURL('accounts/:accountId/kanban/new'),
    name: 'kanban_new_pipeline',
    component: KanbanView,
    props: () => ({ openNewPipeline: true }),
    meta: {
      permissions: KANBAN_PERMISSIONS,
      escopos: ['kanban:manage'],
      featureFlag: FEATURE_FLAGS.KANBAN,
    },
  },
  {
    path: frontendURL('accounts/:accountId/kanban/:pipelineId'),
    name: 'kanban_pipeline',
    component: KanbanView,
    props: route => ({ pipelineId: route.params.pipelineId }),
    meta: {
      permissions: KANBAN_PERMISSIONS,
      escopos: ESCOPOS_DO_QUADRO,
      featureFlag: FEATURE_FLAGS.KANBAN,
    },
  },
];

export default { routes };
